/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2542
 */

var r = require(/* 864 */"./2541/864")
var i = require(/* 865 */"../../../../../253/2568/2569/2570/865/index")
module.exports = function (e, t) {
  return e && r(t, i(t), e)
}
